<div class="row justify-content-between no-gutters">
  <div class="header-text">
    <h1 class=" header-title">{{ title }}</h1>
    <h6 class="header-subtitle">
      {{ subtitle }}
    </h6>
  </div>
  <div class="add-city" *ngIf="button == 'add-city'" (click)="openCity()"></div>
  <div
    class="add-venue"
    *ngIf="button == 'add-venue'"
    (click)="openVenue()"
  ></div>
</div>
